var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExerciseSpeaking = function SvgExerciseSpeaking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#exercise-speaking_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 14.8,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.3,
    stroke: "url(#exercise-speaking_svg__b)",
    strokeLinecap: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#exercise-speaking_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#exercise-speaking_svg__d)",
    d: "M10.789 9.525c0-2.83 2.333-5.125 5.21-5.125 2.668 0 4.867 1.97 5.175 4.51l-1.03.381-.6.147a4.74 4.74 0 0 1-2.605-.098l-.13-.043a.826.826 0 0 0-1.041.512.806.806 0 0 0 .52 1.024l.13.042a6.4 6.4 0 0 0 3.526.134l.69-.17.577-.213v1.603l-1.035.291-.85.21a4.74 4.74 0 0 1-2.263 0l-.863-.213a.824.824 0 0 0-.998.589.81.81 0 0 0 .598.981l.864.213a6.4 6.4 0 0 0 3.06 0l.877-.216.61-.171c-.039 2.798-2.357 5.054-5.211 5.054-2.878 0-5.211-2.295-5.211-5.125z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#exercise-speaking_svg__e)",
    d: "M7.223 13.032c.454 0 .823.363.823.81 0 4.32 3.56 7.823 7.954 7.823 4.393 0 7.954-3.503 7.954-7.823 0-.447.369-.81.823-.81s.823.363.823.81c0 4.942-3.86 8.997-8.777 9.407v2.412q.356.045.707.132l.864.212c.44.109.709.548.599.982a.824.824 0 0 1-.998.589l-.864-.213a4.74 4.74 0 0 0-2.262 0l-.864.213a.824.824 0 0 1-.998-.59.81.81 0 0 1 .599-.98l.864-.213a6 6 0 0 1 .707-.132v-2.412C10.26 22.84 6.4 18.784 6.4 13.842c0-.447.368-.81.823-.81"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "exercise-speaking_svg__b",
    x1: 1.2,
    x2: 30.815,
    y1: 1.2,
    y2: 30.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "exercise-speaking_svg__d",
    x1: 16.162,
    x2: 47.499,
    y1: 32.542,
    y2: 7.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "exercise-speaking_svg__e",
    x1: 16.162,
    x2: 47.499,
    y1: 32.542,
    y2: 7.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("filter", {
    id: "exercise-speaking_svg__a",
    width: 79.6,
    height: 79.6,
    x: -23.8,
    y: -23.8,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_725_1553"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_725_1553",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "exercise-speaking_svg__c",
    width: 67.2,
    height: 71.2,
    x: -17.6,
    y: -19.6,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_725_1553"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_725_1553",
    result: "shape"
  })))));
};
export { SvgExerciseSpeaking as ReactComponent };